import { Controller } from "@hotwired/stimulus"

// Navigates a list of options using the arrow keys (ArrowUp/ArrowDown)
// The cursor is an 'active' data attribute, managed by the activeIndexValue

export default class extends Controller {
  static targets = ["option"]
  static values = { activeIndex: { type: Number, default: 0 } }

  navigateUp() {
    this.activeIndexValue = Math.max(this.activeIndexValue - 1, 0)
    this.visibleOptions[this.activeIndexValue].scrollIntoView({
      block: "nearest",
      inline: "nearest"
    })
  }

  navigateDown() {
    this.activeIndexValue = Math.min(
      this.activeIndexValue + 1,
      this.visibleOptions.length - 1
    )
    this.visibleOptions[this.activeIndexValue].scrollIntoView({
      block: "nearest",
      inline: "nearest"
    })
  }

  navigateTo(event) {
    const option = event.target.closest(
      "[data-list-navigation-target='option']"
    )
    if (option) {
      this.activeIndexValue = this.visibleOptions.indexOf(option)
    }
  }

  reset() {
    this.activeIndexValue = 0
    this.#setActiveOption()
  }

  activeIndexValueChanged() {
    this.#setActiveOption()
  }

  get visibleOptions() {
    return this.optionTargets.filter(
      (option) => option.classList.contains("tw:hidden") === false
    )
  }

  #setActiveOption() {
    this.optionTargets.forEach((option) => {
      option.dataset.active = "false"
    })

    const activeOption = this.visibleOptions[this.activeIndexValue]

    if (activeOption) {
      activeOption.dataset.active = "true"
    }
  }
}
